import { useId, useState } from "react";

// Case-insensitive substring filter over league names (pure, unit-tested).
export const filterLeagues = (leagues, query) => {
  const q = (query || "").trim().toLowerCase();
  if (!q) return leagues || [];
  return (leagues || []).filter((l) => (l.name || "").toLowerCase().includes(q));
};

// Shared game selection is a draft; linking video remains an explicit action.
export const GameSelector = ({ leagues = [], game, onChange }) => {
  const g = game || {};
  const set = (patch) => onChange({ year: g.year || "", league_id: g.league_id || "", game_no: g.game_no || "", ...patch });
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const selected = leagues.find((l) => l.id === g.league_id);
  const matches = filterLeagues(leagues, query).slice(0, 60);
  const listId = useId();
  const [activeIndex, setActiveIndex] = useState(0);
  const choose = (league) => { set({ league_id: league.id }); setOpen(false); };
  const handleKeyDown = (e) => {
    if (e.key === "Escape") { setOpen(false); e.stopPropagation(); return; }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      setOpen(true);
      setActiveIndex((i) => Math.max(0, Math.min(matches.length - 1, i + (e.key === "ArrowDown" ? 1 : -1))));
    } else if (e.key === "Enter" && open && matches[activeIndex]) {
      e.preventDefault();
      choose(matches[activeIndex]);
    }
  };
  return (
    <div className="game-selector">
      <label className="setup-field">年份
        <input className="gs-year" placeholder="年份" inputMode="numeric" value={g.year || ""} onChange={(e) => set({ year: e.target.value })} />
      </label>
      <div className="gs-league setup-field">
        <label htmlFor={`${listId}-input`}>聯盟</label>
        <input id={`${listId}-input`} className="gs-league-input" placeholder="搜尋聯賽"
          role="combobox" aria-expanded={open} aria-controls={listId} aria-autocomplete="list"
          aria-activedescendant={open && matches[activeIndex] ? `${listId}-${activeIndex}` : undefined}
          value={open ? query : selected ? selected.name : ""}
          onFocus={() => { setOpen(true); setQuery(""); setActiveIndex(0); }}
          onChange={(e) => { setQuery(e.target.value); setActiveIndex(0); setOpen(true); }}
          onBlur={() => setOpen(false)} onKeyDown={handleKeyDown} aria-label="搜尋聯賽" />
        {open && (
          <ul id={listId} role="listbox" aria-label="聯盟選項" className="gs-league-list">
            {matches.length === 0 && <li className="gs-empty">無符合聯賽</li>}
            {matches.map((l, i) => (
              <li id={`${listId}-${i}`} role="option" aria-selected={l.id === g.league_id}
                key={l.id} className={`gs-league-item${i === activeIndex ? " active" : ""}`}
                onMouseDown={(e) => { e.preventDefault(); choose(l); }} onMouseEnter={() => setActiveIndex(i)}>
                <span>{l.name}</span><span className="gs-games">{l.games}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      <label className="setup-field">現況賽事編號
        <input className="gs-gameno" placeholder="賽事編號" value={g.game_no || ""} onChange={(e) => set({ game_no: e.target.value })} />
      </label>
    </div>
  );
};
